import { render, staticRenderFns } from "./platePanel.vue?vue&type=template&id=273de0ea&scoped=true"
import script from "./platePanel.vue?vue&type=script&lang=js"
export * from "./platePanel.vue?vue&type=script&lang=js"
import style0 from "./platePanel.vue?vue&type=style&index=0&id=273de0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273de0ea",
  null
  
)

export default component.exports